<template>
    <div class="form-wrap">

        <div class="sub-visual sub-visual--sv6">
            <v-container>
                <h2 class="sub-visual__title color-white"><span>데모신청</span></h2>
            </v-container>
        </div>

        <section class="sub-section">
            <v-container>

                <h6 class="page-text-lg font-weight-bold text-center mb-30 mb-lg-52">
                    {{ settings.demo }}
                </h6>

                <p class="text-right page-text-sm line-height-1 mb-4 mb-lg-8"><span style="color:#ff2d2d">*</span> 필수입력입니다</p>
                <div class="table-style table-style--default">
                    <div class="table-style__row">
                        <div class="table-style__th">성명 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.name" v-bind="$attrs" placeholder="성명" outlined hide-details clearable />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">연락처 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <v-select v-model="phone1" :items="prependPhones" v-bind="$attrs" placeholder="연락처" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="phone2" v-bind="$attrs" maxlength="4" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="phone3" v-bind="$attrs" maxlength="4" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">이메일 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <v-text-field v-model="email1" v-bind="$attrs" placeholder="이메일" outlined hide-details @input="() => emailJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">@</v-col>
                                        <v-col>
                                            <v-text-field v-model="email2" v-bind="$attrs" outlined hide-details @input="() => emailJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-select v-model="email3" v-bind="$attrs" persistent-hint :items="prependEmails" item-text="text" item-value="value" outlined hide-details @input="email2 = email3"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">회사명 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.companyName" v-bind="$attrs" placeholder="회사명" outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">사용환경 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.os" v-bind="$attrs" placeholder="[Windows], [Linux{CentOS, Ubuntu}].." outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">WEB Servers / WAS 종류 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.server" v-bind="$attrs" placeholder="WEB Servers / WAS 종류" outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">운행대행 필요여부 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-radio-group v-model="demo.need" row hide-details>
                                            <v-radio label="필요" value="필요" color="primary"></v-radio>
                                            <v-radio label="불필요" value="불필요" color="primary"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">기타문의 <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-textarea rows="9" v-model="demo.content" outlined hide-details></v-textarea>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>

                <div class="agree-box px-16 py-32 py-lg-60 mt-12 mt-lg-20">
                    <!-- <label>
                        <input v-model="agree" type="checkbox" >
                        <span>개인정보 수집·이용 동의</span>
                    </label> -->

                    <v-checkbox v-model="agree" label="개인정보 수집·이용 동의" value="개인정보 수집·이용 동의" hide-details></v-checkbox>

                    <a href="/privacy-policy" class="d-inline-block ml-8 ml-lg-20 color-grey-49 page-text-sm line-height-12" style="border-bottom: 1px solid #494949">
                        전문보기
                        <i></i>
                    </a>
                </div>
                <div class="mt-30 mt-lg-60 text-center">
                    <v-btn x-large color="primary" @click="submit">신청하기</v-btn>
                </div>
            </v-container>
        </section>

    </div>
</template>
<script>

import api from "@/api";

export default {
    components: {
    },
    data(){
        return {

            demo:{
                name: null,
                phone: null,
                email: null,
                companyName: null,
                os: null,
                server: null,
                need: null,
                content: null
            },

            phone1: "010",
            phone2: null,
            phone3: null,

            email1: null,
            email2: null,
            email3: null,

            agree: false,

            prependPhones: [
                { text: "010", value: "010" },
                { text: "011", value: "011" },
                { text: "016", value: "016" },
                { text: "017", value: "017" },
                { text: "019", value: "019" }
            ],
            prependEmails: [
                { text: ":: 직접입력 ::", value: null },
                { text: "naver.com", value: "naver.com" },
                { text: "gmail.com", value: "gmail.com" },
                { text: "daum.net", value: "daum.net" },
                { text: "hanmail.net", value: "hanmail.net" },
            ],
            settings: null,

            filter: {
                code: "ko"
            }
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        },
        validate(){
            try{
                let demo = this.demo
                if(!demo.name) throw new Error('성명을 입력해주세요')
                if(!demo.phone || !this.phone1 || !this.phone2 || !this.phone3) throw new Error('연락처를 입력해주세요')
                if(!demo.email || !this.email1 || !this.email2) throw new Error('이메일을 입력해주세요')
                if(!demo.companyName) throw new Error('회사명을 입력해주세요')
                if(!demo.os) throw new Error('사용환경을 입력해주세요')
                if(!demo.server) throw new Error('WEB server을 입력해주세요')
                if(demo.need === null) throw new Error('운행대행 필요여부를 선택해주세요')
                if(!demo.content) throw new Error('기타문의를 입력해주세요')
                if(!this.agree) throw new Error('개인정보 수집·이용에 동의해주세요')
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async submit(){
            if(this.validate()){
                let demo = this.demo
                let { success } = await api.v1.message.post({ demo })
                if(success){
                    alert('데모신청 되었습니다')
                    this.$router.push('/')
                }
            }
        },
        phoneNumberJoin(){
            this.demo.phone = `${this.phone1}-${this.phone2}-${this.phone3}`
        },
        emailJoin(){
            this.demo.email = `${this.email1}@${this.email2}`
        },
    },
    watch:{
        email3(){
            this.emailJoin()
        }
    }
}
</script>

<style scoped>
.agree-box{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f4f7fb;
    border-radius: 6px;
}
</style>